import {
  ACCEPT_STATE_I18N_MAP,
  PROCESS_STATE_I18N_MAP,
} from '~/modules/delivery-notes/list/constants';

import { DELIVERY_NOTE_FILTER_NAME } from '../useQueryDeliveryNotesAdmin';

export const DELIVERY_NOTE_FILTER_ENTITY_NAMES =
  DELIVERY_NOTE_FILTER_NAME.filter(
    (name) => !['category', 'is_mapped'].includes(name),
  );

export const ACCEPT_STATE_OPTIONS = Object.values(ACCEPT_STATE_I18N_MAP());

export const PROCESS_STATE_OPTIONS = Object.values(PROCESS_STATE_I18N_MAP());
